import React, { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { useTranslation } from 'react-i18next'
import { popupIcon } from 'Assets/Icons'
import apiAdapterCoffeeWeb from 'Services/apiAdapter_CoffeeWeb'
import DialogUIModal from 'Components/UIComponent/DialogUIModal'
import { Toast } from 'primereact/toast'
import { getLocalUserDetails } from 'Utils/LocalStorage_Handler'

export default function Vietnam({ swapReport, setLoading, mockVietnamData, mockFetchedVietnamData, mockShowModal, createMonthRange, checkForUserAccess, reportName }) {
  const { t } = useTranslation()
  const toast = useRef(null)
  const location = useLocation()
  const fullPath = location.pathname
  const pathSegments = fullPath.split('/')
  const desiredPath = pathSegments[2] || ''
  const userDetails = getLocalUserDetails()
  let menuLock

  if (userDetails && userDetails.menus) {
    const menu = userDetails.menus.find(({ menuUrl }) => menuUrl === desiredPath)

    if (menu) {
      menuLock = menu.menulock
    }
  }

  const [fetchedData, setFetchedData] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [currentData, setCurrentData] = useState({})
  const [previousData, setPreviousData] = useState({})
  const [currentYear, setCurrentYear] = useState('')
  const [previousYear, setPreviousYear] = useState('')
  const [modalType, setModalType] = useState(null)

  //  Testing Purpose
  useEffect(() => {
    if (mockVietnamData) {
      setFetchedData(mockFetchedVietnamData)
    }

    setShowModal(mockShowModal)
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)

      try {
        const response = await apiAdapterCoffeeWeb.getDataByReportName({ reportName })

        setFetchedData(response.data)
      } catch (error) {
        // console.log(error)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [])

  const calculateTotals = (countryCertifiedData) => {
    const totals = {
      MT: 0
    }

    countryCertifiedData.forEach(({ MT }) => {
      totals.MT += Number(MT) || 0
    })

    return totals
  }

  const convertMTToBags = (valueInMT) => {
    if (valueInMT === '' || Number.isNaN(Number(valueInMT))) {
      return ''
    }
    const result = (valueInMT * 1000) / 60

    return Math.round(result)
  }

  const convertToMillion = (value) => {
    if (value === '' || Number.isNaN(Number(value))) {
      return ''
    }

    const result = value / 60000

    return result.toFixed(4)
  }

  const calculateTotalsWithMonth = (data) => {
    const totals = {
      MT: 0,
      MONTH: ''
    }

    data.forEach(({ MT, MONTH }) => {
      totals.MT += Number(MT) || 0

      if (MONTH) {
        totals.MONTH = MONTH
      }
    })

    return totals
  }

  const getTextColor = (value) => {
    if (value === 0) {
      return 'neutral'
    }
    if (value > 0) {
      return 'positive'
    }

    return 'negative'
  }

  const showMonthValueModal = (currentIndex, selectedYear) => {
    const filteredData = fetchedData.find(({ year }) => year === selectedYear)

    const selectedIndex = fetchedData.findIndex(({ year }) => year === selectedYear)

    const nextData = selectedIndex !== -1 && selectedIndex + 1 < fetchedData.length ? fetchedData[selectedIndex + 1] : null

    if (!filteredData || !nextData) {
      toast.current.show({ severity: 'error', summary: t('NO_DATA'), detail: t('NO_DATA_FOR_PREVIOUS_YEAR'), life: 3000 })

      return
    }

    const currentYearData = filteredData?.report[currentIndex]
    const previousYearData = nextData?.report[currentIndex]

    const currentYearValue = filteredData?.year.split(' : ')[1]
    const previousYearValue = nextData?.year.split(' : ')[1]

    setCurrentData(currentYearData)
    setPreviousData(previousYearData)
    setCurrentYear(currentYearValue)
    setPreviousYear(previousYearValue)
    setModalType('month')
    setShowModal(true)

    if (currentYearData?.MT !== '' && previousYearData?.MT !== '') {
      setShowModal(true)
    } else {
      setShowModal(false)
      toast.current.show({ severity: 'error', summary: t('NO_DATA'), detail: t('NO_DATA_FOR_SELECTED_YEAR'), life: 3000 })
    }
  }

  const showTotalValueModal = (selectedYear) => {
    const filteredData = fetchedData.find(({ year }) => year === selectedYear)

    const selectedIndex = fetchedData.findIndex(({ year }) => year === selectedYear)

    const nextData = selectedIndex !== -1 && selectedIndex + 1 < fetchedData.length ? fetchedData[selectedIndex + 1] : null

    if (!filteredData || !nextData) {
      toast.current.show({ severity: 'error', summary: t('NO_DATA'), detail: t('NO_DATA_FOR_PREVIOUS_YEAR'), life: 3000 })

      return
    }

    const totalValue = []

    const updateData = filteredData?.report.filter((ele) => ele.MT)

    for (let i = 0; i < updateData.length; i++) {
      const elementCopy = { ...nextData?.report[i] }

      totalValue.push(elementCopy)
    }

    if (filteredData && nextData) {
      const currentYearTotal = calculateTotalsWithMonth(updateData)
      const previousYearTotal = calculateTotalsWithMonth(totalValue)

      const currentYearValue = filteredData?.year.split(' : ')[1]
      const previousYearValue = nextData?.year.split(' : ')[1]

      setCurrentData(currentYearTotal)
      setPreviousData(previousYearTotal)

      setCurrentYear(currentYearValue)
      setPreviousYear(previousYearValue)
      setModalType('total')

      if (currentYearTotal && previousYearTotal) {
        setShowModal(true)
      }
    }
  }

  const displayValue = (value) => {
    if (value === '' || value === null || value === undefined) return '--'

    const numericValue = Number(value)

    if (swapReport === 'Metric Tons') {
      return numericValue.toLocaleString()
    }

    if (swapReport === '60 KG Bags') {
      return convertMTToBags(numericValue).toLocaleString()
    }

    if (swapReport === 'Millions Bags') {
      return convertToMillion(numericValue)
    }

    return numericValue.toLocaleString()
  }

  const comparisonTableData = () => {
    if (!currentData || !previousData) {
      return null
    }

    const difference = {
      mt: Number(currentData.MT) - Number(previousData.MT) || 0
    }

    const percentageDifference = {
      mt: previousData.MT ? ((difference.mt / Number(previousData.MT)) * 100).toFixed(2) : 'N/A'
    }

    const currentMonth = currentData.MONTH?.split('-')[0]
    const previousMonth = previousData.MONTH?.split('-')[0]

    const currentMonthYear = `${currentMonth} - ${currentYear}`
    const previousMonthYear = previousData ? `${previousMonth} - ${previousYear}` : ''

    const dynamicTitle = modalType === 'total' ? `Upto ${currentMonthYear} To ${previousMonthYear} Comparison` : `${currentMonthYear} To ${previousMonthYear} Comparison`

    return (
      <div className="comparison-table" data-testid="vietnam-comparison-table">
        <div className="content-title" data-testid="table-content-title">
          <h5 data-testid="table-heading">{dynamicTitle}</h5>
        </div>
        <table>
          <thead>
            <tr>
              <th>{t('MONTH')}</th>
              <th>{t('EXPORTS')}</th>
            </tr>
          </thead>
          <tbody>
            <tr className="empty-table-row"></tr>
            <tr>
              <td data-testid="current-month-data">{modalType === 'total' ? createMonthRange(currentData.MONTH) : currentData.MONTH}</td>
              <td data-testid="current-MT-data">{displayValue(Math.round(currentData.MT))}</td>
            </tr>

            <tr>
              {modalType === 'total' ? <td data-testid="previous-month-data">{createMonthRange(previousData ? previousData.MONTH : '')}</td> : <td data-testid="previous-month-data">{previousData ? previousData.MONTH : ''}</td>}
              <td data-testid="previous-MT-data">{displayValue(Math.round(previousData.MT))}</td>
            </tr>

            <tr className="empty-table-row"></tr>

            <tr className="difference-row" data-testid="difference-row">
              <td className="table-border">{t('DIFFERENCE')}</td>
              <td data-testid="difference-MT-Value" className={`${getTextColor(difference.mt)} table-border`}>
                {displayValue(Math.round(difference.mt))}
              </td>
            </tr>

            <tr className="percentage-row" data-testid="percentage-row">
              <td className="table-border">{t('PERCENTAGE_WISE')}</td>
              <td data-testid="percentage-difference-value" className={`${getTextColor(percentageDifference.mt)} table-border`}>
                {percentageDifference.mt !== 'N/A' ? `${percentageDifference.mt}%` : 'N/A'}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

  return (
    <div className="horizontal-scroll-container" id="port-wise-stock-report" data-testid="scroll-container">
      {fetchedData?.map(({ report, year }, index) => {
        const { MT } = calculateTotals(report)

        return (
          <div key={index} className="table-wrapper" data-testid="table-wrapper">
            <table>
              <thead>
                <tr className="year-row" data-testid="year-row">
                  <td colSpan={6}>
                    <div data-testid="year-value">{year}</div>
                  </td>
                </tr>
                <tr>
                  <th className="month">{t('MONTH')}</th>
                  <th>EXPORTS</th>
                </tr>
                <tr className="table-row-empty"></tr>
              </thead>
              <tbody style={checkForUserAccess(menuLock)}>
                {report.map(({ MONTH, MT }, index) => (
                  <tr key={index}>
                    <td>
                      <div className="popup-wrapper" data-testid="popup-wrapper" onClick={() => userDetails && !menuLock && showMonthValueModal(index, year)}>
                        <div data-testid="month-value">{MONTH}</div>
                        <div className="icon-wrapper" data-testid="icon-wrapper">
                          <img src={popupIcon} alt={MONTH} className="popup-icon" />
                        </div>
                      </div>
                    </td>
                    <td data-testid="MT-Table-data">{displayValue(MT) || '--'}</td>
                  </tr>
                ))}
                <tr className="no-data-row"></tr>

                <tr className="tr-color" data-testid="table-row-color">
                  <td>
                    <div className="popup-wrapper" onClick={() => userDetails && !menuLock && showTotalValueModal(year)}>
                      <div>{t('TOTAL')}</div>
                      <div className="icon-wrapper">
                        <img src={popupIcon} alt={'icon'} className="popup-icon" />
                      </div>
                    </div>
                  </td>
                  <td>{displayValue(MT)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )
      })}

      <Toast ref={toast} position="top-right" />

      <DialogUIModal title={modalType === 'total' ? t('TOTAL_COMPARISON_DATA') : t('MONTH_COMPARISON_DATA')} showModal={showModal} handleClose={() => setShowModal(false)} bodyContent={comparisonTableData} titlePosition="center" size="lg" />
    </div>
  )
}
